__turbopack_context__.v({
  "email-form": "email-subscribe-form-module-scss-module__6EF3eq__email-form",
});
